import React from 'react';
import { Flex } from 'app/components/common/Flex';
import { MapLayerUtils, MapObjectType, ObjectToDisplay } from 'app/components/dashboard/network/map/Map';
import memoizeOne from 'memoize-one';
import { Tree } from 'antd';
import { OTSRoute } from 'app/model/CORE';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';

interface LayerContentPopupProps {
    objects: Array<ObjectToDisplay>;
}

export default class LayerContentPopup extends React.PureComponent<LayerContentPopupProps> {
    render() {
        if (this.props.objects?.length > 0) {
            const perType = this.getPerType(this.props.objects);
            const treeData = [];
            Array.from(perType.keys()).forEach(type => {
                treeData.push({
                    key: type,
                    title: MapLayerUtils.getMapObjectTypeName(type),
                    children: perType.get(type).map(obj => ({
                        key: this.getTypeChildrenKey({ type: type, object: obj }),
                        title: MapLayerUtils.getObjectToDisplayKey({ type: type, object: obj }),
                        children: this.getTypeEntryChildren(
                            this.getTypeChildrenKey({ type: type, object: obj }),
                            type,
                            obj,
                        ),
                    })),
                });
            });
            return (
                <Flex direction="vertical" style={{ minHeight: '25em', padding: '3em' }}>
                    <Tree defaultExpandAll={true} treeData={treeData} />
                </Flex>
            );
        }
    }

    private getTypeChildrenKey(objectToDisplay: ObjectToDisplay) {
        return `${objectToDisplay.type}-${MapLayerUtils.getObjectToDisplayKey(objectToDisplay)}`;
    }

    private getPerType = memoizeOne((objects: Array<ObjectToDisplay>) => {
        return objects?.reduce((map, object) => {
            if (!map.has(object.type)) {
                map.set(object.type, []);
            }
            map.get(object.type).push(object.object);
            return map;
        }, new Map<MapObjectType, Array<any>>());
    });

    private getTypeEntryChildren(parentKey: string, type: MapObjectType, obj: any) {
        switch (type) {
            case MapObjectType.NAT_TRACK: {
                const otsRoute: OTSRoute = obj as OTSRoute;
                if (otsRoute?.routeAvailabilities?.length > 0) {
                    return otsRoute.routeAvailabilities.map(rtAvl => ({
                        key: parentKey + '-' + TimePeriodUtils.formatDDHHMM(rtAvl.availabilityPeriod),
                        title: TimePeriodUtils.formatDDHHMM(rtAvl.availabilityPeriod),
                    }));
                }
                break;
            }
        }
        return undefined;
    }
}
